import { Box, Image, useColorModeValue, chakra } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';

interface Props {
  isCollapsed?: boolean;
  onClick?: (event: React.SyntheticEvent) => void;
  className?: string;
}

const NetworkLogo = ({ onClick, className }: Props) => {
  const darkModeFilter = { filter: 'brightness(0) invert(1)' };
  const logoStyle = useColorModeValue({}, !config.UI.navigation.logo.dark ? darkModeFilter : {});

  return (
    <Box
      className={ className }
      as="a"
      href={ route({ pathname: '/' }) }
      display="inline-flex"
      overflow="hidden"
      onClick={ onClick }
      flexShrink={ 1 }
      minWidth="100px"
      height="40px"
      aria-label="Link to main page"
    >
      <Image
        w="auto"
        h="100%"
        maxH="40px"
        src="/static/logo_name_white.png"
        alt={ `${ config.chain.name } network logo` }
        // style={ logoStyle }
        objectFit="contain"
        display="block"
      />
    </Box>
  );
};

export default React.memo(chakra(NetworkLogo));
